import React, {Component} from 'react'

import {List, ListItem, Typography} from '@material-ui/core'

import PaperBlock from "../../../ui/PaperBlock"

/**
 * attachments
 * selected
 * 
 * onClickAttachment 
 * onDoubleClickAttachment
 */

class AttachmentsList extends Component {

    render() {
        let attachments = this.props.attachments ? this.props.attachments : []
        return <PaperBlock>
            <List>
                {attachments.map((attachment, key) => 
                    <ListItem 
                        style = {{display: "flex", gap: "10px"}}
                        key = {key}
                        button
                        selected = {this.props.selected ? this.props.selected["id"] === attachment["id"] : false}
                        onClick = {e => {
                            e.stopPropagation()
                            if (typeof this.props.onClickAttachment === "function") {
                                this.props.onClickAttachment(attachment)
                            }
                        }}
                        onDoubleClick = {e => {
                            e.stopPropagation()
                            if (typeof this.props.onDoubleClickAttachment === "function") {
                                this.props.onDoubleClickAttachment(attachment)
                            }
                        }}
                    >
                        <div style = {{flex: "1 1 auto"}}>
                            <Typography variant='h5'>{attachment.item.name}</Typography>
                            <Typography variant='subtitle1'>Магазин: {attachment.shop ? attachment.shop.name : <Typography inline variant='subtitle1' color = "textSecondary"> не указан </Typography>}</Typography>
                        </div>
                        <Typography variant='subtitle1' style = {{flex: "0 0 50px", textAlign: "center"}}>{attachment.quantity}</Typography>
                    </ListItem>
                )}
            </List>
        </PaperBlock>
    }

}

export default AttachmentsList